import React from 'react';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
export function SegmentDashboardMockup() {
  const segments = [{
    name: 'Deal Hunters',
    subscribers: 4200,
    openRate: 68,
    clickRate: 12.4,
    trend: 'up',
    color: 'bg-emerald-500'
  }, {
    name: 'Self-Care Enthusiasts',
    subscribers: 3100,
    openRate: 72,
    clickRate: 15.8,
    trend: 'up',
    color: 'bg-blue-500'
  }, {
    name: 'Sponsor Clickers',
    subscribers: 2800,
    openRate: 65,
    clickRate: 18.2,
    trend: 'up',
    color: 'bg-purple-500'
  }];
  const overallStats = {
    openRate: 45,
    clickRate: 8.1
  };
  return <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 w-full" data-id="element-648">
            {/* Header */}
            <div className="mb-6" data-id="element-649">
                <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-650">
                    Audience Segments
                </h3>
                <p className="text-sm text-gray-500" data-id="element-651">Performance overview</p>
            </div>

            {/* Overall Stats Card */}
            <div className="bg-gray-50 rounded-lg p-4 mb-6 border border-gray-200" data-id="element-652">
                <div className="flex items-center justify-between mb-2" data-id="element-653">
                    <span className="text-sm font-medium text-gray-600" data-id="element-654">
                        Overall List
                    </span>
                    <span className="text-xs text-gray-500" data-id="element-655">9,100 subscribers</span>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-656">
                    <div data-id="element-657">
                        <div className="text-2xl font-bold text-gray-700" data-id="element-658">
                            {overallStats.openRate}%
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-659">Open Rate</div>
                    </div>
                    <div data-id="element-660">
                        <div className="text-2xl font-bold text-gray-700" data-id="element-661">
                            {overallStats.clickRate}%
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-662">Click Rate</div>
                    </div>
                </div>
            </div>

            {/* Segment Cards */}
            <div className="space-y-4" data-id="element-663">
                {segments.map((segment, index) => <div key={index} className="bg-white rounded-lg p-4 border border-gray-200 hover:border-gray-300 transition-colors" data-id="element-664">
                        <div className="flex items-center justify-between mb-3" data-id="element-665">
                            <div className="flex items-center" data-id="element-666">
                                <div className={`w-3 h-3 rounded-full ${segment.color} mr-2`} data-id="element-667" />
                                <span className="font-semibold text-gray-900" data-id="element-668">
                                    {segment.name}
                                </span>
                            </div>
                            <span className="text-xs text-gray-500" data-id="element-669">
                                {segment.subscribers.toLocaleString()} subs
                            </span>
                        </div>

                        <div className="grid grid-cols-2 gap-4" data-id="element-670">
                            <div data-id="element-671">
                                <div className="flex items-center" data-id="element-672">
                                    <span className="text-xl font-bold text-gray-900" data-id="element-673">
                                        {segment.openRate}%
                                    </span>
                                    {segment.trend === 'up' && <TrendingUpIcon className="w-4 h-4 text-green-500 ml-1" data-id="element-674" />}
                                </div>
                                <div className="text-xs text-gray-500" data-id="element-675">Open Rate</div>
                                <div className="text-xs text-green-600 font-medium mt-1" data-id="element-676">
                                    +{segment.openRate - overallStats.openRate}% vs overall
                                </div>
                            </div>

                            <div data-id="element-677">
                                <div className="flex items-center" data-id="element-678">
                                    <span className="text-xl font-bold text-gray-900" data-id="element-679">
                                        {segment.clickRate}%
                                    </span>
                                    {segment.trend === 'up' && <TrendingUpIcon className="w-4 h-4 text-green-500 ml-1" data-id="element-680" />}
                                </div>
                                <div className="text-xs text-gray-500" data-id="element-681">Click Rate</div>
                                <div className="text-xs text-green-600 font-medium mt-1" data-id="element-682">
                                    +{(segment.clickRate - overallStats.clickRate).toFixed(1)}% vs
                                    overall
                                </div>
                            </div>
                        </div>
                    </div>)}
            </div>

            {/* Footer Note */}
            <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-683">
                <p className="text-xs text-gray-500 text-center" data-id="element-684">
                    Segments automatically update based on subscriber behavior
                </p>
            </div>
        </div>;
}